import { axiosHelper } from 'Services/AxiosHelper';
import { OnSaveCustomerCardModel } from 'Models';
import { saveRegisterCardTransactionBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';

const command = 'RI.OnSaveRegisteredCard';

const saveRegisterCard = async (params: saveRegisterCardTransactionBodyData): Promise<OnSaveCustomerCardModel> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default saveRegisterCard;
